import makeStyles from '@mui/styles/makeStyles';

export const useHeaderIconStyles = makeStyles((theme) => ({
    iconButton: {
        backgroundColor: theme.palette.background.iconPressed,
    },
    iconHover: {
        borderRadius: 6,
        '&:hover': {
            backgroundColor: theme.palette.background.dialogBorder,
        },
    },
}));